/**
 * src/components/LoadingIndicator.js
 * A reusable loading indicator component
 */

import React from 'react';
import './LoadingIndicator.css';

const LoadingIndicator = ({ message = 'Yükleniyor...' }) => {
  return (
    <div className="loading-indicator">
      <div className="spinner"></div>
      <p className="loading-message">{message}</p>
    </div>
  );
};

export default LoadingIndicator;